import {UyapRequest} from "./UyapRequest";
import app from "@/main";
import {ISorguSonuc} from "@/plugins/uyap-plugin/uyap/CommonInterfaces";


export interface BorcluGsmTalep {
    dosyaId: string|number,
    kisiKurumId: number,
    sorguBakiye: number | string,
}

export interface BorcluGsmCevap extends ISorguSonuc<IGSM> {}

export interface BorcluGsmCevapRow {
    operator: string,
    adres: string
}

export interface IGSM {
    hizmetBilgileri: Array<any>,
    adresBilgileri: Array<IAdresBilgileri>,
    kurumBilgileri: Array<any>,
    kimlikBilgileri: Array <any>,
    sonucAciklama: string,
    sonucKodu: number,
    operatorTuru: string
}

export interface IAdresBilgileri {
    adres: string,
    ilcesi: string,
    ili?: number,
    ilAdi?: string
}

export default class BorcluGsm extends UyapRequest<BorcluGsmTalep, BorcluGsmCevap> {
    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "Borçlu GSM bilgileri sorgulanıyor...";
    }

    cache() {
        return {
            active: true,
            ttl: (60 * 24), //* 1 gun
            key: "borcluGsm_" + app.$uyapHelper.hash(this.talepData)
        };
    }

    getMockResponse(): any {
        return {"borcluBilgileri":{"kisiTumDVO":{"olumKaydi":false,"isAvukat":false,"isGecerlilikAktifAvukat":false,"isNoter":false,"isTarafUyari":false,"isHakimSavci":false,"mernisDegisiklikVarmi":false,"mernisDegisiklikNedeni":"","sorguTuru":0,"tcKimlikNo":"4********10","adi":"AH**** MÜ***","soyadi":"YA*******","babaAdi":"A*********","anaAdi":"Ş*****","dogumTarihiStr":"1957","aktifMernisAdresiSorgusu":true,"hasOlumKaydi":false},"kisiKurumId":28698317,"turu":0},"sorgulayanBilgileri":"Av.NİHAN ERDOĞAN","portalTuru":2,"dosyaOzetDVO":{"birimDVO":{"birimAdi":"Ankara 2. Genel İcra Dairesi","birimId":"1000963","orgKodu":"1.04.011.000.6037","duzey1":"1","duzey2":"04","duzey3":"011","duzey4":"000","duzey5":"6037","birimTuru1":"11","birimTuru2":"1101","birimTuru3":"1199","evraginBirimDVODaGonderilecegiBirimBilgisi":0,"yeniBirimEkle":true,"orgKoduDegisti":false,"isTumunuKopyala":false,"eskiAd":"","eskiOrgKod":"","taranmamisKaydetme":"","testMi":0},"rolIdList":[],"isBirimKapali":false,"dosyaTurKod":35,"dosyaTurAd":"İcra Dosyası","dosyaNo":"2023/27440","dosyaNoYil":2023,"dosyaSira":27440,"dosyaId":"013@RlwAzAkR3QHUdOJ2IvnecVaCdMxo8M@fbnw3GtBUEhQiqFWl1@Lm@ZOKGt35","dosyaAcilisTarihi":"08/07/2023 10:35","genelDosyaDurumu":"Açık","genelDosyaDurumuAsInteger":0,"taraflar":"ABDULSELAM DENİZ, AHMETİ MÜNÜR YALÇINALP","vekilId":0,"vekilMi":false,"vekilHazineAvukatiMi":false},"sorguTarihi":"10/09/2024 16:27","sorguSonucDVO":[{"hizmetBilgileri":[],"adresBilgileri":[{"adres":"DEMETLALE MAH. 405. CADDE GÜVEN APT. NO:77/C","ili":6,"ilcesi":"YENİMAHALLE","ilAdi":"ANKARA"},{"adres":"GÜVEN APT NO:77/C DEMETLALE Mah.06200 YENİMAHALLE ANKARA","ili":60,"ilcesi":"YENİMAHALLE","ilAdi":"TOKAT"}],"kurumBilgileri":[],"kimlikBilgileri":[],"sonucAciklama":"Listeleme Basarili!","sonucKodu":0,"operatorTuru":"Vodafone"},{"hizmetBilgileri":[],"adresBilgileri":[{"adres":"4. CD.","ilcesi":"YENİMAHALLE "}],"kurumBilgileri":[],"kimlikBilgileri":[],"sonucAciklama":"Listeleme Basarili!","sonucKodu":0,"operatorTuru":"Türk Telekom"},{"hizmetBilgileri":[],"adresBilgileri":[{"adres":"4. Cad. Güven Apt. 77/C Yenimahalle 6200","ili":6,"ilcesi":"Yenimahalle","ilAdi":"ANKARA"}],"kurumBilgileri":[],"kimlikBilgileri":[],"sonucAciklama":"Listeleme Basarili!","sonucKodu":0,"operatorTuru":"Turkcell"}],"sorgulamaTuru":"GSM","sorguSonucu":true,"hasError":false,"hasData":false,"isMock":false};
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'borclu_bilgileri_goruntule_gsm.ajx';
    }

    async parse(data: any): Promise<BorcluGsmCevap> {
        data.message = "Sorgulama Başarılı";
        return data;
    }
}